__turbopack_context__.v({
  "accordion": "accordionWrapper-module-scss-module__EQW-9G__accordion",
  "accordionContainer": "accordionWrapper-module-scss-module__EQW-9G__accordionContainer",
  "accordionContent": "accordionWrapper-module-scss-module__EQW-9G__accordionContent",
  "accordionItemHeader": "accordionWrapper-module-scss-module__EQW-9G__accordionItemHeader",
  "borderBottom": "accordionWrapper-module-scss-module__EQW-9G__borderBottom",
  "borderTopHidden": "accordionWrapper-module-scss-module__EQW-9G__borderTopHidden",
});
